<!-- app-content-header start -->
<ng-container *ngIf="contentHeader">
  <div class="content-header row">
    <div class="content-header-left col-md-8 col-12 mb-2">
      <div class="row breadcrumbs-top">
        <div class="col-12 d-flex">
          <h2 class="content-header-title float-left mb-0">
            {{ contentHeader.headerTitle }}
          </h2>
          <!-- app-breadcrumb component -->
          <app-breadcrumb [breadcrumb]="contentHeader.breadcrumb"></app-breadcrumb>
        </div>
      </div>
    </div>
    <ng-container *ngIf="contentHeader.actionButton">
      <div class="content-header-right text-md-right col-md-4 col-12 d-md-block">
        <div class="form-group breadcrum-right">

          <div ngbDropdown>
            <!-- Add *ngIf to conditionally render the button based on the current route -->
            <button  *ngIf="checkRouteContains('/portal/affidavit/')" (click)="navigateToNewApplication()"
              class="btn btn-outline-primary btn-round mr-75" type="button" rippleEffect>
              <span class="mr-25" [data-feather]="'plus'"></span>
              New Application
            </button>
            <button *ngIf="checkRouteContains('/portal/affidavit/')" ngbDropdownToggle class="btn btn-primary"
              type="button" id="dropdownMenuButton" rippleEffect>
              <span class="mr-25" [data-feather]="'link'"></span>
              Quick Links
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
              <a ngbDropdownItem [routerLink]="['/portal/selection']"><span [data-feather]="'folder'"
                  [class]="'mr-50'"></span>
                Module Selection</a>
              <a ngbDropdownItem [routerLink]="['/portal/affidavit/dashboard']"><span [data-feather]="'home'"
                  [class]="'mr-50'"></span>
                Dashboard</a>
              <a ngbDropdownItem [routerLink]="['/portal/affidavit/applications/list']"><span
                  [data-feather]="'file-text'" [class]="'mr-50'"></span>
                List of Applications</a>
              <a ngbDropdownItem [routerLink]="['/portal/affidavit/affidavits/list']"><span [data-feather]="'file-text'"
                  [class]="'mr-50'"></span>
                List of Affidavits</a>
                <a ngbDropdownItem [routerLink]="['/portal/affidavit/verify-remita-payment']"><span [data-feather]="'file-text'"
                  [class]="'mr-50'"></span>
                Verify Remita Payment</a>
            </div>
          </div>



          <div ngbDropdown>
            <!-- Add *ngIf to conditionally render the button based on the current route -->
            <button *ngIf="checkRouteContains('/portal/probate/')" routerLink="/portal/probate/list"
              class="btn btn-outline-primary btn-round mr-75" type="button" rippleEffect>
              <span class="mr-25" [data-feather]="'list'"></span>
              Probate Applications
            </button>

            <button *ngIf="checkRouteContains('/portal/probate/')" ngbDropdownToggle class="btn btn-primary"
              type="button" id="dropdownMenuButton" rippleEffect>
              <span class="mr-25" [data-feather]="'link'"></span>
              Quick Links
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
              <a ngbDropdownItem [routerLink]="['/portal/selection']"><span [data-feather]="'folder'"
                  [class]="'mr-50'"></span>
                Module Selection</a>
              <a ngbDropdownItem [routerLink]="['/portal/probate/willdeposit']"><span [data-feather]="'home'"
                  [class]="'mr-50'"></span>
                Will deposit</a>
              <a ngbDropdownItem [routerLink]="['/portal/probate/legal-publication']"><span [data-feather]="'file-text'"
                  [class]="'mr-50'"></span>
                Publications</a>
              <a ngbDropdownItem [routerLink]="['/portal/probate/resealing-list']"><span [data-feather]="'file-text'"
                  [class]="'mr-50'"></span>
                Applications for Resealing</a>
              <a ngbDropdownItem [routerLink]="['/portal/probate/payment-list']"><span [data-feather]="'file-text'"
                  [class]="'mr-50'"></span>
                List of Payments</a>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
<!-- app-content-header end -->